import { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { useUserRoles } from '@/hooks/useUserRoles';
import { Loader2 } from 'lucide-react';

type AppRole = 'owner' | 'admin' | 'investor' | 'auditor' | 'observer';

interface ProtectedActionProps {
  allowedRoles: AppRole[];
  companyId?: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function ProtectedAction({
  allowedRoles,
  companyId,
  children,
  fallback,
}: ProtectedActionProps) {
  const { hasAnyRole, loading } = useUserRoles(companyId);

  if (loading) {
    return (
      <Button variant="secondary" disabled>
        <Loader2 className="h-4 w-4 animate-spin" />
      </Button>
    );
  }

  const isAllowed = hasAnyRole(allowedRoles, companyId);

  if (isAllowed) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <Button
      variant="secondary"
      disabled
      onClick={() => toast.error('You do not have permission for this action')}
    >
      Restricted
    </Button>
  );
}
